<div class="cr-review-panel" [class.compact]="compact">
  <ng-container *ngIf="!compact; else compactTpl">
    <app-review-version-bar-v2
      [versions]="state.versions"
      [viewing]="state.viewing"
      [latest]="state.latest"
      [languageLabel]="languageLabel"
      (selectVersion)="onSelectVersion($event)"
      (newVersion)="newVersion.emit()"
    ></app-review-version-bar-v2>
    <app-review-decisions-v2
      *ngIf="state.latest !== null"
      [decisions]="viewingDecisions"
      (submitDecision)="onSubmitDecision($event)"
    ></app-review-decisions-v2>
    <div class="cr-review-tabs" role="tablist">
      <button type="button" class="cr-review-tab" [class.active]="tab === 'activity'" (click)="tab = 'activity'">Activity</button>
      <button type="button" class="cr-review-tab" [class.active]="tab === 'timeline'" (click)="tab = 'timeline'">Timeline</button>
    </div>
    <app-review-timeline-v2 *ngIf="tab === 'timeline'" [events]="timeline"></app-review-timeline-v2>
    <ng-container *ngIf="tab === 'activity'">
      <div class="cr-review-empty" *ngIf="state.latest === null; else activityTpl">
        <span class="cr-review-empty-icon" aria-hidden="true">
          <svg viewBox="0 0 32 32" focusable="false"><path d="M7.5 6.5h17a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-7l-4.6 4v-4H7.5a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2Z"></path></svg>
        </span>
        <strong>No version in review yet.</strong>
        <span>Press <b>Pull current version</b> to bring the current {{ languageLabel }} content in for review. The editor keeps working on the live content.</span>
      </div>
      <ng-template #activityTpl>
        <div class="cr-older-notice" role="note" *ngIf="isOlder">
          <span class="cr-older-notice-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="12" r="8.5"></circle><path d="M12 10.7v5"></path><path d="M12 7.7h.01"></path></svg>
          </span>
          <span class="cr-older-notice-copy"><strong>There is newer version available.</strong></span>
          <span class="cr-older-notice-actions">
            <button type="button" class="cr-link-btn" (click)="goToLatest()">Go to Version {{ state.latest }}</button>
            <button type="button" class="cr-link-btn" [disabled]="!canRestore" [title]="canRestore ? '' : 'Lock this language before restoring'" (click)="onRestore()">Restore this version</button>
          </span>
        </div>
        <ng-container *ngIf="!isOlder">
          <button type="button" class="cr-add-comment-btn" *ngIf="!state.composerOpen" (click)="openComposer()">
            <span class="cr-add-plus">+</span>
            <span>Add comment</span>
          </button>
          <div class="cr-composer" *ngIf="state.composerOpen">
            <textarea class="cr-composer-input" [(ngModel)]="composerText" placeholder="Add a comment..."></textarea>
            <div class="cr-composer-note" role="note">
              <span class="cr-composer-note-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" focusable="false"><circle cx="12" cy="12" r="8.5"></circle><path d="M12 10.7v5"></path><path d="M12 7.7h.01"></path></svg>
              </span>
              <span class="cr-composer-note-copy"><strong>Info</strong><span>Click the newsletter to place a pin.</span></span>
            </div>
            <div class="cr-composer-pin" *ngIf="state.composerPin">
              <span>📍 Pin placed</span>
              <button type="button" class="cr-link-btn" (click)="removeComposerPin()">Remove</button>
            </div>
            <div class="cr-composer-actions">
              <button type="button" class="cr-btn cr-btn-primary" (click)="submitComposer()">Submit</button>
              <button type="button" class="cr-link-btn" (click)="cancelComposer()">Cancel</button>
            </div>
          </div>
        </ng-container>
        <ng-container *ngTemplateOutlet="groupsTpl"></ng-container>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-template #compactTpl>
    <ng-container *ngIf="groups.length; else compactEmpty">
      <ng-container *ngTemplateOutlet="groupsTpl"></ng-container>
    </ng-container>
    <ng-template #compactEmpty>
      <div class="cr-empty-comments">No comments yet.<br />Comments are written on <strong>Proof</strong> and show up here while you edit.</div>
    </ng-template>
  </ng-template>

  <ng-template #groupsTpl>
    <div class="cr-version-groups">
      <section
        class="cr-version-group"
        *ngFor="let g of groups; trackBy: trackGroup"
        [class.is-viewing]="!compact && g.version?.version === state.viewing"
        [class.plain]="!g.version"
      >
        <div class="cr-version-group-head">
          <span class="cr-version-group-label">{{ g.version ? 'Version ' + g.version.version : 'Earlier comments' }}</span>
          <span class="cr-version-group-meta">
            <span class="cr-version-group-count">{{ countLabel(g) }}</span>
            <ng-container *ngIf="!compact && g.version">
              <span class="cr-viewing-pill" *ngIf="g.version.version === state.viewing">Viewing</span>
              <button
                type="button"
                class="cr-version-group-open"
                *ngIf="g.version.version !== state.viewing"
                (click)="onSelectVersion(g.version.version)"
              >
                View version {{ g.version.version }} <span aria-hidden="true">↗</span>
              </button>
            </ng-container>
          </span>
        </div>
        <div class="cr-version-group-body">
          <ng-container *ngIf="!compact && g.version">
            <article class="cr-decision-entry" *ngFor="let d of newestFirst(g.version.decisions)">
              <div class="cr-decision-entry-head">
                <span class="cr-decision-dot" [ngClass]="'tone-' + decisionTypeOf(d).tone"></span>
                <span class="cr-decision-entry-label">{{ decisionTypeOf(d).label }}</span>
              </div>
              <div class="cr-decision-entry-meta">
                <span>{{ decisionAuthor(d) }}</span>
                <span>{{ d.createdDate | date: 'dd-MM-yyyy HH:mm' }}</span>
              </div>
              <div class="cr-decision-entry-comment" *ngIf="d.comment">{{ d.comment }}</div>
            </article>
          </ng-container>
          <app-review-comment-card-v2
            *ngFor="let c of g.comments; trackBy: trackComment"
            [comment]="c"
            [number]="numbers.get(c.notificationId!) ?? null"
            [currentUsername]="currentUsername"
            [active]="c.notificationId === state.activeCommentId"
            (toggleDone)="onToggleDone(c)"
            (saveEdit)="onSaveEdit(c, $event)"
            (deleteComment)="onDelete(c)"
            (annotate)="onAnnotate(c)"
            (showAnnotation)="onShowAnnotation(c)"
            (addReply)="onAddReply(c, $event)"
            (saveReply)="onSaveReply(c, $event)"
          ></app-review-comment-card-v2>
          <div class="cr-version-group-empty" *ngIf="g.comments.length === 0">No comments on this version.</div>
        </div>
      </section>
    </div>
  </ng-template>
</div>
